import { SupagardRegistrationSchema } from './supagard-registration';

export const EditDynamicFormMap: { [key: string]: any } = {
  SUPAGARD: {
    REGISTRATION: SupagardRegistrationSchema,
  },
  HYCLOR: {
    REGISTRATION: {},
  },
};
